// extracted by css-extract-rspack-plugin
export default {"button":"_1a8ed705","reducedLineHeight":"_d9eed586"};